import { render, staticRenderFns } from "./Plant.vue?vue&type=template&id=85cbc34a&scoped=true&"
import script from "./Plant.vue?vue&type=script&lang=js&"
export * from "./Plant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cbc34a",
  null
  
)

export default component.exports